import { render } from "./DetectGatewayForm.vue?vue&type=template&id=e8ee460e"
import script from "./DetectGatewayForm.vue?vue&type=script&lang=js"
export * from "./DetectGatewayForm.vue?vue&type=script&lang=js"
script.render = render

export default script